// The "Open 2d 4h 10m" badge: how long a case has waited, coloured by age. One
// helper for the lawyer's case list and the certifier's queue, so both read the
// same at a glance.

export const DAY_MS = 86400000;

export const formatElapsed = (fromMs: number, nowMs: number): string => {
  let remaining = Math.max(0, Math.floor((nowMs - fromMs) / 1000));
  const days = Math.floor(remaining / 86400);
  remaining -= days * 86400;
  const hours = Math.floor(remaining / 3600);
  remaining -= hours * 3600;
  const minutes = Math.floor(remaining / 60);
  return `${days}d ${hours}h ${minutes}m`;
};

// Map how long a case has been waiting to a severity class so stale cases
// stand out:
//   < 1 day  -> fresh (green)
//   1-3 days -> aging (amber)
//   > 3 days -> stale (red)
export const elapsedSeverityClass = (fromMs: number, nowMs: number): string => {
  const elapsedMs = Math.max(0, nowMs - fromMs);
  if (elapsedMs >= 3 * DAY_MS) return 'case-open-elapsed--stale';
  if (elapsedMs >= 1 * DAY_MS) return 'case-open-elapsed--aging';
  return 'case-open-elapsed--fresh';
};
